<tn-dialog-shell testId="start-service" [title]="'Start {service} Service' | translate: { service: serviceHumanName }">
  <ix-fake-progress-bar [loading]="isLoading"></ix-fake-progress-bar>

  <p class="description">
    {{ '{service} Service is not currently running. Start the service now?' | translate: { service: serviceHumanName } }}
  </p>

  <!--
    The control is bound by reference, not by name, so `tn-slide-toggle` has no control name to
    derive an id from — `testId` carries the bare `toggle` value the legacy slide toggle resolved to.
  -->
  <tn-slide-toggle
    testId="toggle"
    [formControl]="startAutomaticallyControl"
    [label]="'Enable this service to start automatically.' | translate"
  ></tn-slide-toggle>

  <ix-form-actions tnDialogAction class="form-actions">
    <tn-button
      variant="outline"
      testId="do-not-start"
      [label]="'No' | translate"
      [disabled]="isLoading"
      (onClick)="onCancel()"
    ></tn-button>

    <tn-button
      color="primary"
      testId="enable-service"
      [label]="'Start' | translate"
      [disabled]="isLoading"
      (onClick)="onSubmit()"
    ></tn-button>
  </ix-form-actions>
</tn-dialog-shell>
